import { FC } from 'react';

import { Text, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import { Banner } from 'components/Admin/ModerationList/CampaignModeration/Banner/Banner';

import { CampaignModerationInfo } from 'store/models/moderation';

import styles from 'components/Admin/ModerationList/CampaignModeration/CampaignModeration.module.less';

export const CampaignModeration: FC<{ campaign: CampaignModerationInfo }> = ({ campaign }) => {
    const { campaignId, campaignName, banners } = campaign;

    if (banners.length === 0) {
        return null;
    }

    return (
        <div>
            <div className={styles.titleWrapper}>
                <Text
                    typography="title-3-semibold"
                    style="secondary"
                    data-qa={`moderation-campaign-title-${campaignId}`}
                >
                    {campaignName}
                </Text>
                <Text typography="label-3-regular" style="secondary" data-qa={`moderation-campaign-id-${campaignId}`}>
                    {`#${campaignId}`}
                </Text>
            </div>
            <VSpacing default={40} />
            <VSpacingContainer default={40}>
                {banners.map((banner) => (
                    <Banner key={banner.bannerId} banner={banner} campaignId={campaignId} isModeration />
                ))}
            </VSpacingContainer>
            <VSpacing default={52} />
        </div>
    );
};
